import React from 'react';

export const Container = props => {
    return (
        <div className="marketkit-pagination-container">
            { props.children }
        </div>
    );
}
 
export default Container